import { DoqFaceSvgProps } from '../types';

const Error = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 144 144"
    fill="none"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_1698_48455)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-error">
        <circle cx="72" cy="72" r="72" fill="white" />
        <path d="M 108,135 A 72,72 0 0,1 36,135 L 72,72 Z" fill="black" />
      </mask>
      <circle
        cx="72"
        cy="72"
        r="72"
        fill="#CC3D3D"
        mask="url(#bottom-mask-error)"
      />

      <mask
        id="mask0_1698_48455"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="144"
        height="144"
      >
        <circle cx="72" cy="72" r="72" fill="#A5184B" />
      </mask>
      <g mask="url(#mask0_1698_48455)">
        <path
          d="M79.4209 54L82.6626 57.1461L85.9037 54H97.3687L108 64.3198L108 87.1483L107.905 86.965L102.674 97.0853L107.852 102.112L104.154 105.702L107.99 109.426L108 109.416L108 136.8C108 140.776 104.776 144 100.8 144H43.2003C39.2239 144 36.0003 140.776 36.0003 136.8L36 124.943L39.7938 121.261L36.8775 118.429L38.8921 116.474L36 113.665V89.8803L38.8075 87.1554L36.1872 84.6117L48.7944 54H79.4209Z"
          fill="white"
        />
        <path
          d="M79.4209 54L82.6626 57.1461L85.9037 54H97.3687L108 64.3198L108 87.1483L107.905 86.965L102.674 97.0853L107.852 102.112L104.154 105.702L107.99 109.426L108 109.416L108 136.8C108 140.776 104.776 144 100.8 144H43.2003C39.2239 144 36.0003 140.776 36.0003 136.8L36 124.943L39.7938 121.261L36.8775 118.429L38.8921 116.474L36 113.665V89.8803L38.8075 87.1554L36.1872 84.6117L48.7944 54H79.4209Z"
          fill="white"
        />
        <rect x="36" y="124" width="72" height="20" />
      </g>
      <path
        d="M67.4998 79.1088C67.4998 81.097 65.888 82.7088 63.8998 82.7088C61.9116 82.7088 60.2998 81.097 60.2998 79.1088C60.2998 77.1206 61.9116 75.5088 63.8998 75.5088C65.888 75.5088 67.4998 77.1206 67.4998 79.1088Z"
        fill="#2974C4"
      />
      <path
        opacity="0.299691"
        d="M80.8276 74.427C81.9699 73.2847 83.8219 73.2847 84.9642 74.427C86.1065 75.5693 86.1065 77.4213 84.9642 78.5636L79.5548 83.973C78.4125 85.1153 76.5605 85.1153 75.4182 83.973C74.276 82.8307 74.276 80.9787 75.4182 79.8364L80.8276 74.427Z"
        fill="#FF78A8"
      />
      <path
        opacity="0.790471"
        d="M79.5548 74.427C78.4125 73.2847 76.5605 73.2847 75.4182 74.427C74.276 75.5693 74.276 77.4213 75.4182 78.5636L80.8276 83.973C81.9699 85.1153 83.8219 85.1153 84.9642 83.973C86.1065 82.8307 86.1065 80.9787 84.9642 79.8364L79.5548 74.427Z"
        fill="#E5A3BB"
      />
      <path
        opacity="0.317701"
        d="M80.6687 77.4499C80.3173 77.0984 79.7474 77.0984 79.3959 77.4499L78.4413 78.4045C78.0899 78.7559 78.0899 79.3258 78.4413 79.6773L79.3959 80.6319C79.7474 80.9833 80.3173 80.9833 80.6687 80.6319L81.6233 79.6773C81.9748 79.3258 81.9748 78.7559 81.6233 78.4045L80.6687 77.4499Z"
        fill="#141414"
      />
      <path
        d="M87.8046 45.1186L86.888 44.3609C86.4547 44.0023 86.2204 43.4314 86.2593 42.8251L86.3409 41.5425L85.5788 42.5774C85.219 43.0669 84.6722 43.3545 84.1101 43.3498L82.9209 43.341L83.8376 44.0987C84.2711 44.4565 84.5051 45.0282 84.4662 45.6345L84.3847 46.9171L85.1467 45.8822C85.5065 45.3927 86.0533 45.1052 86.6154 45.1098L87.8046 45.1186Z"
        fill="#FFC356"
      />
      <path
        d="M100.494 46.7784L100.678 48.1936L99.6414 47.2126C99.1519 46.7485 98.4367 46.5534 97.7203 46.6885L96.2046 46.9732L97.3258 45.9142C97.8562 45.414 98.1187 44.7208 98.031 44.0519L97.8466 42.6368L98.8831 43.6178C99.3726 44.0818 100.088 44.277 100.804 44.1419L102.32 43.8572L101.199 44.9162C100.668 45.4164 100.407 46.1092 100.494 46.7784Z"
        fill="#FFC356"
      />
      <path
        d="M109.881 56.3829L109.264 58.0202L108.647 56.3829C108.356 55.6088 107.648 55.0018 106.744 54.7523L104.834 54.2233L106.744 53.6942C107.648 53.4447 108.356 52.8377 108.647 52.0637L109.264 50.4264L109.881 52.0637C110.172 52.8377 110.88 53.4447 111.784 53.6942L113.694 54.2233L111.784 54.7523C110.88 55.0018 110.174 55.6088 109.881 56.3829Z"
        fill="#FFC356"
      />
      <path
        d="M104.769 68.3601L104.477 66.6002C104.339 65.7679 104.636 64.891 105.276 64.243L106.631 62.8712L104.75 63.293C103.861 63.493 102.959 63.2804 102.327 62.722L100.989 61.5417L101.281 63.3016C101.42 64.1333 101.122 65.0108 100.482 65.6588L99.1272 67.0306L101.008 66.6088C101.897 66.4089 102.799 66.6214 103.431 67.1798L104.769 68.3601Z"
        fill="#FFC356"
      />
      <path
        d="M87.3163 73.7857L86.8489 70.97C86.6287 69.6383 87.1032 68.2353 88.1284 67.1985L90.2956 65.0036L87.2858 65.6784C85.8633 65.9983 84.4202 65.6583 83.4093 64.7649L81.2691 62.8764L81.7365 65.6921C81.9585 67.0228 81.4821 68.4269 80.457 69.4637L78.2897 71.6585L81.2996 70.9837C82.7221 70.6638 84.1652 71.0038 85.176 71.8972L87.3163 73.7857Z"
        fill="#FFC356"
      />
      <path
        d="M61.114 74.2202L61.7312 72.5829C62.0236 71.8088 62.7305 71.2018 63.6336 70.9523L65.5437 70.4233L63.6336 69.8942C62.7305 69.6447 62.0223 69.0377 61.7312 68.2637L61.114 66.6264L60.4968 68.2637C60.2057 69.0377 59.4975 69.6447 58.5945 69.8942L56.6843 70.4233L58.5945 70.9523C59.4975 71.2018 60.2057 71.8088 60.4968 72.5829L61.114 74.2202Z"
        fill="#FFC356"
      />
      <path
        d="M69.7291 45.9201L70.6457 46.6778L69.4565 46.6689C68.8944 46.6643 68.3476 46.9519 67.9878 47.4413L67.2258 48.4763L67.3073 47.1937C67.3462 46.5874 67.1122 46.0157 66.6787 45.6579L65.762 44.9002L66.9512 44.909C67.5133 44.9136 68.0601 44.6261 68.42 44.1366L69.182 43.1017L69.1005 44.3843C69.0615 44.9906 69.2958 45.5615 69.7291 45.9201Z"
        fill="#FFC356"
      />
      <path
        d="M50.8421 46.8571L50.2005 46.3267C49.8972 46.0757 49.7332 45.6761 49.7604 45.2517L49.8175 44.3538L49.2841 45.0783C49.0322 45.4209 48.6495 45.6222 48.256 45.619L47.4235 45.6128L48.0652 46.1432C48.3687 46.3936 48.5325 46.7938 48.5052 47.2182L48.4482 48.1161L48.9816 47.3916C49.2335 47.049 49.6162 46.8477 50.0097 46.8509L50.8421 46.8571Z"
        fill="#FFC356"
      />
      <path
        d="M34.199 54.8486L33.7041 56.2901L33.2092 54.8486C32.9759 54.1671 32.408 53.6327 31.6839 53.413L30.1523 52.9473L31.6839 52.4815C32.408 52.2618 32.9759 51.7274 33.2092 51.0459L33.7041 49.6044L34.199 51.0459C34.4324 51.7274 35.0002 52.2618 35.7243 52.4815L37.2559 52.9473L35.7243 53.413C35.0002 53.6327 34.4334 54.1671 34.199 54.8486Z"
        fill="#FFC356"
      />
      <path
        d="M43.6033 72.0283L44.473 69.5226C44.8849 68.338 45.8809 67.409 47.1533 67.0271L49.8446 66.2175L47.1533 65.4078C45.8809 65.026 44.8831 64.097 44.473 62.9123L43.6033 60.4066L42.7337 62.9123C42.3236 64.097 41.3258 65.026 40.0533 65.4078L37.362 66.2175L40.0533 67.0271C41.3258 67.409 42.3236 68.338 42.7337 69.5226L43.6033 72.0283Z"
        fill="#FFC356"
      />
      <g opacity="0.5">
        <path
          d="M43.1992 109.35C43.1992 109.101 43.4007 108.9 43.6492 108.9H100.349C100.598 108.9 100.799 109.101 100.799 109.35V110.25C100.799 110.498 100.598 110.7 100.349 110.7H43.6492C43.4007 110.7 43.1992 110.498 43.1992 110.25V109.35Z"
          fill="#2974C4"
        />
        <path
          d="M43.1992 124.65C43.1992 124.401 43.4007 124.2 43.6492 124.2H100.349C100.598 124.2 100.799 124.401 100.799 124.65V125.55C100.799 125.798 100.598 126 100.349 126H43.6492C43.4007 126 43.1992 125.798 43.1992 125.55V124.65Z"
          fill="#2974C4"
        />
        <path
          d="M43.6492 116.1C43.4007 116.1 43.1992 116.301 43.1992 116.55V117.45C43.1992 117.698 43.4007 117.9 43.6492 117.9H100.349C100.598 117.9 100.799 117.698 100.799 117.45V116.55C100.799 116.301 100.598 116.1 100.349 116.1H43.6492Z"
          fill="#2974C4"
        />
        <path
          d="M43.1992 131.85C43.1992 131.601 43.4007 131.4 43.6492 131.4H100.349C100.598 131.4 100.799 131.601 100.799 131.85V132.75C100.799 132.998 100.598 133.2 100.349 133.2H43.6492C43.4007 133.2 43.1992 132.998 43.1992 132.75V131.85Z"
          fill="#2974C4"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.8328 90.0025C72.3671 90.0368 72 90.4255 72 90.9C72 91.3971 72.4029 91.8 72.9 91.8H79.425C80.2948 91.8 81 92.5052 81 93.375C81 93.4515 80.9945 93.5268 80.984 93.6004L81 93.6005C81.0002 94.0973 81.4031 94.5 81.9 94.5C82.3971 94.5 82.8 94.0971 82.8 93.6C82.8 93.5737 82.7989 93.5476 82.7967 93.5219L82.7926 93.6003C82.7975 93.5258 82.8 93.4507 82.8 93.375C82.8 91.511 81.289 90 79.425 90H72.9L72.8328 90.0025Z"
        fill="#2974C4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1698_48455">
        <rect width="144" height="144" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { Error };
